import { render, staticRenderFns } from "./SynergismMatterDimensionsTab.vue?vue&type=template&id=028ba93c&scoped=true&"
import script from "./SynergismMatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./SynergismMatterDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./SynergismMatterDimensionsTab.vue?vue&type=style&index=0&id=028ba93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ba93c",
  null
  
)

export default component.exports